import './conditions.scss';

import { State } from './js/state';
import { bindEvents } from './js/events';

jQuery(function ($) {
	const { ajaxurl, nonce, all_conditions } =
		window.devnet_snap_blocks_conditions_script_data || {};

	State.init(all_conditions || {});

	bindEvents($, { ajaxurl, nonce });
});
